var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip"},[_vm._v("\n    "+_vm._s(_vm.tooltip)),_c('span',{staticClass:"tooltip-text",class:_vm.position},[_vm._v(_vm._s(_vm.tooltipText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }